import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { Button, Stack } from '@mui/material';
import { useEffect, useState } from 'react';
import { AppLocalStorage } from '../../../../data/LocalStorage/AppLocalStorage';
import { NavSections } from '../../../navigation/NavSections';
const contextHeadings = ['customerName', 'propertyName', 'groupName', 'entityName'];
const networkHeadings = ['nwID', 'nasSourceIp', 'app_id'];
const gatewayHeadings = ['gatewayEui', 'gatewayLat', 'gatewayLng', 'gatewayDOP'];
const deviceHeadings = [
    'deviceEui',
    'deviceType',
    'devState',
    'deviceLat',
    'deviceLng',
    'devFCntJumpDaily',
    'devMessageCntDaily',
    'devDoP',
    'battery',
    'batteryV',
    'batteryCharging',
    'temperature',
    'humidity',
];
const receptionHeadings = [
    'distance',
    'consumedAirtimeSecs',
    'esp',
    'rssi',
    'snr',
    'port',
    'sf',
    'power',
    'port',
    'frequency',
    'channel',
];
const bearingHeadings = ['GtD', 'DBear', 'DtG'];
const messageHeadings = ['linkType', 'fCnt', 'fCntInc', 'size', 'payloadStr'];
export const useBasicColumVisibility = ({ setColumnVisibilityModel }) => {
    const initialContext = AppLocalStorage.get(NavSections.NETWORKTABLEVIEW, 'showingContext') ?? true;
    const initialNetwork = AppLocalStorage.get(NavSections.NETWORKTABLEVIEW, 'showingNetwork') ?? true;
    const initialGateway = AppLocalStorage.get(NavSections.NETWORKTABLEVIEW, 'showingGateway') ?? true;
    const initialDevice = AppLocalStorage.get(NavSections.NETWORKTABLEVIEW, 'showingDevice') ?? true;
    const initialReception = AppLocalStorage.get(NavSections.NETWORKTABLEVIEW, 'showingReception') ?? true;
    const initialBearing = AppLocalStorage.get(NavSections.NETWORKTABLEVIEW, 'showingBearing') ?? true;
    const initialMessage = AppLocalStorage.get(NavSections.NETWORKTABLEVIEW, 'showingMessage') ?? true;
    const [showingContext, setShowingContext] = useState(initialContext);
    const [showingNetwork, setShowingNetwork] = useState(initialNetwork);
    const [showingGateway, setShowingGateway] = useState(initialGateway);
    const [showingDevice, setShowingDevice] = useState(initialDevice);
    const [showingReception, setShowingReception] = useState(initialReception);
    const [showingBearing, setShowingBearing] = useState(initialBearing);
    const [showingMessage, setShowingMessage] = useState(initialMessage);
    const hideHeadings = (headings) => setColumnVisibilityModel((m) => {
        headings.forEach((heading) => (m[heading] = false));
        return m;
    });
    const showHeadings = (headings) => setColumnVisibilityModel((m) => {
        headings.forEach((heading) => (m[heading] = true));
        return m;
    });
    useEffect(() => {
        if (!initialContext)
            hideHeadings(contextHeadings);
        if (!initialNetwork)
            hideHeadings(networkHeadings);
        if (!initialGateway)
            hideHeadings(gatewayHeadings);
        if (!initialDevice)
            hideHeadings(deviceHeadings);
        if (!initialReception)
            hideHeadings(receptionHeadings);
        if (!initialBearing)
            hideHeadings(bearingHeadings);
        if (!initialMessage)
            hideHeadings(messageHeadings);
    }, []);
    const controls = [
        _jsxs(Stack, { direction: "row", gap: 1, children: [_jsx(Button, { id: "Context", size: 'small',
                    variant: 'outlined',
                    style: { textTransform: 'none', width: '100px', opacity: showingContext ? 1 : 0.65 },
                    endIcon: showingContext ? _jsx(VisibilityIcon, {}) : _jsx(VisibilityOffIcon, {}),
                    onClick: () => {
                        setShowingContext(!showingContext);
                        AppLocalStorage.set(NavSections.NETWORKTABLEVIEW, 'showingContext', !showingContext);
                        showingContext ? hideHeadings(contextHeadings) : showHeadings(contextHeadings);
                    }, children: "Context" }, "Context"), _jsx(Button, { id: "Network", size: 'small',
                    variant: 'outlined',
                    style: { textTransform: 'none', width: '100px', opacity: showingNetwork ? 1 : 0.65 },
                    endIcon: showingNetwork ? _jsx(VisibilityIcon, {}) : _jsx(VisibilityOffIcon, {}),
                    onClick: () => {
                        setShowingNetwork(!showingNetwork);
                        AppLocalStorage.set(NavSections.NETWORKTABLEVIEW, 'showingNetwork', !showingNetwork);
                        showingNetwork ? hideHeadings(networkHeadings) : showHeadings(networkHeadings);
                    }, children: "Network" }, "Network"), _jsx(Button, { id: "Gateway", size: 'small',
                    variant: 'outlined',
                    style: { textTransform: 'none', width: '100px', opacity: showingGateway ? 1 : 0.65 },
                    endIcon: showingGateway ? _jsx(VisibilityIcon, {}) : _jsx(VisibilityOffIcon, {}),
                    onClick: () => {
                        setShowingGateway(!showingGateway);
                        AppLocalStorage.set(NavSections.NETWORKTABLEVIEW, 'showingGateway', !showingGateway);
                        showingGateway ? hideHeadings(gatewayHeadings) : showHeadings(gatewayHeadings);
                    }, children: "Gateway" }, "Gateway"), _jsx(Button, { id: "Device", size: 'small',
                    variant: 'outlined',
                    style: { textTransform: 'none', width: '100px', opacity: showingDevice ? 1 : 0.65 },
                    endIcon: showingDevice ? _jsx(VisibilityIcon, {}) : _jsx(VisibilityOffIcon, {}),
                    onClick: () => {
                        setShowingDevice(!showingDevice);
                        AppLocalStorage.set(NavSections.NETWORKTABLEVIEW, 'showingDevice', !showingDevice);
                        showingDevice ? hideHeadings(deviceHeadings) : showHeadings(deviceHeadings);
                    }, children: "Device" }, "Device"), _jsx(Button, { id: "Reception", size: 'small',
                    variant: 'outlined',
                    style: { textTransform: 'none', width: '100px', opacity: showingReception ? 1 : 0.65 },
                    endIcon: showingReception ? _jsx(VisibilityIcon, {}) : _jsx(VisibilityOffIcon, {}),
                    onClick: () => {
                        setShowingReception(!showingReception);
                        AppLocalStorage.set(NavSections.NETWORKTABLEVIEW, 'showingReception', !showingReception);
                        showingReception ? hideHeadings(receptionHeadings) : showHeadings(receptionHeadings);
                    }, children: "Reception" }, "Reception"), _jsx(Button, { id: "Bearing", size: 'small',
                    variant: 'outlined',
                    style: { textTransform: 'none', width: '100px', opacity: showingBearing ? 1 : 0.65 },
                    endIcon: showingBearing ? _jsx(VisibilityIcon, {}) : _jsx(VisibilityOffIcon, {}),
                    onClick: () => {
                        setShowingBearing(!showingBearing);
                        AppLocalStorage.set(NavSections.NETWORKTABLEVIEW, 'showingBearing', !showingBearing);
                        showingBearing ? hideHeadings(bearingHeadings) : showHeadings(bearingHeadings);
                    }, children: "Bearing" }, "Bearing"), _jsx(Button, { id: "Message", size: 'small',
                    variant: 'outlined',
                    style: { textTransform: 'none', width: '100px', opacity: showingMessage ? 1 : 0.65 },
                    endIcon: showingMessage ? _jsx(VisibilityIcon, {}) : _jsx(VisibilityOffIcon, {}),
                    onClick: () => {
                        setShowingMessage(!showingMessage);
                        AppLocalStorage.set(NavSections.NETWORKTABLEVIEW, 'showingMessage', !showingMessage);
                        showingMessage ? hideHeadings(messageHeadings) : showHeadings(messageHeadings);
                    }, children: "Message" }, "Message")] }, "BasicColumnVisibility"),
    ];
    return { controls };
};
